import Cookies from 'js-cookie';

function productPromotionInit() {
    const productPromotions = document.querySelectorAll('[data-product-promotion]');

    if (!productPromotions.length) {
        return;
    }

    productPromotions.forEach((productPromotion) => {
        const closeButton = productPromotion.querySelector('[data-product-promotion-close]');

        closeButton.addEventListener('click', () => {
            productPromotion.classList.add('hide');
        });

        if (productPromotion.hasAttribute('data-utm-id')) {
            const cookieUtm = Cookies.get('utm');
            const promotionUtmId = productPromotion.getAttribute('data-utm-id');

            if (cookieUtm !== promotionUtmId) {
                return;
            }

            productPromotion.classList.remove('hide');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    productPromotionInit();
});
